import { InjectionToken } from '@angular/core';

export interface IAppConfig {
  apiUrl: string;
  authUrl: string;
  hasHttps: boolean;
  webAppUrl: string;
  appUrl: string;
  recaptchaSiteKey?: string;
}

export interface CommonEnvironment {
  ENV: 'production' | 'staging' | 'development';
}

export const APP_CONFIG = new InjectionToken('App config');
export const AUTH_TOKEN = new InjectionToken<string>('AUTH_TOKEN');
export const COMPANY_ID = new InjectionToken<number>('COMPANY_ID');
export const AUTH_METHOD = new InjectionToken<string>('AUTH_METHOD');
export const ADMIN = new InjectionToken<any>('ADMIN');
export const ENVIRONMENT = new InjectionToken<CommonEnvironment>('App environment');
export const PATH_WHITELIST = new InjectionToken<string[] | undefined>('White list of paths');
